import service from "./service";
const prefix = "/cm";

export const systemLibrary = {};

export const apiGetDomains = (): Promise<API.DataResponse<
  API.DomainItem[]
>> => service.get("common-uam/tm/domains");

export const getMenuList = () => service.get(prefix + `/plantrack/module`);

export const apiGetProcessesGridField = (
  module?: string
): Promise<API.DataResponse<API.GridsFieldItem[]>> =>
  service.get(prefix + `/processes/grids/fields`);
export const apiGetPlansGridField = (
  module?: string
): Promise<API.DataResponse<API.GridsFieldItem[]>> =>
  service.get(prefix + `/plans/grids/fields`);
export const apiGetReportsGridField = (
  module?: string
): Promise<API.DataResponse<API.GridsFieldItem[]>> =>
  service.get(prefix + `/reports/grids/fields`);
export const apiGetTasksGridField = (
  module?: string
): Promise<API.DataResponse<API.GridsFieldItem[]>> =>
  service.get(prefix + `/tasks/grids/fields`);
